import EventApplicantTileContainer from './event_applicant_tile_container';

const EventApplicantTile = EventApplicantTileContainer;
export default EventApplicantTile;
